import styled from 'styled-components';

export const Tag = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background-color: transparent;
  border: 1px solid #999;
  color: #495057;
  border-radius: 1rem;
  font-size: 0.875rem;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    background-color: #f8f8f8;
    border-color: #747474;
    color: #333;
  }
`;

export const AddTagButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border: 1px solid #999;
  background-color: transparent;
  color: #495057;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  margin: 0;
  flex-shrink: 0;
  
  &:hover {
    background-color: #f8f8f8;
    border-color: #747474;
    color: #333;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(16, 122, 255, 0.3);
  }
`;

export const TagsContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['variant', 'hasContent'].includes(prop),
})`
  display: ${props => props.variant === 'form' ? (props.hasContent ? 'flex' : 'none') : 'flex'};
  align-items: center;
  gap: ${props => props.variant === 'form' ? '0.5rem' : '0.25rem'};
  flex-wrap: ${props => props.variant === 'form' ? 'wrap' : 'nowrap'};
  margin-left: 0;
  margin-top: ${props => props.variant === 'form' ? '0.25rem' : '0'};
  transition: all 0.2s ease;
`;